"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchResponseSchema = exports.searchItemSchema = void 0;
const zod_1 = require("zod");
const datetime_schema_1 = require("../../../common/schemas/datetime.schema");
const subjectField_schema_1 = require("../../../common/schemas/subjectField.schema");
const shortField_schema_1 = require("../../../common/schemas/shortField.schema");
const selectedItemWithName_schema_1 = require("../../../common/schemas/selectedItemWithName.schema");
const ChangeItemStatus_1 = require("../../types/ChangeItemStatus");
const ChangeItemType_1 = require("../../types/ChangeItemType");
exports.searchItemSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    subject: subjectField_schema_1.subjectFieldSchema,
    number: shortField_schema_1.shortFieldSchema,
    status: (0, selectedItemWithName_schema_1.selectedItemWithNameWithSpecificTypeSchema)(ChangeItemStatus_1.ChangeItemStatus),
    changeItemType: (0, selectedItemWithName_schema_1.selectedItemWithNameWithSpecificTypeSchema)(ChangeItemType_1.ChangeItemType),
    receivedDate: datetime_schema_1.datetimeSchema.optional(),
    dueDate: datetime_schema_1.datetimeSchema.optional(),
    disciplines: selectedItemWithName_schema_1.selectedItemWithNameSchema.array(),
    isOverdue: zod_1.z.boolean(),
})
    .strict();
exports.searchResponseSchema = zod_1.z
    .object({
    items: exports.searchItemSchema.array(),
    paging: zod_1.z.object({
        totalCount: zod_1.z.number(),
    }),
})
    .strict();
//# sourceMappingURL=searchResponse.schema.js.map